import React from 'react'
import { useStagingBannerStyles } from './banner.style'

type EnvironmentType = {
  isTest: string
}

export const StagingBanner: React.FC<EnvironmentType> = (props: any): React.ReactElement => {
  const classes = useStagingBannerStyles()

  if (props.isTest !== "true") {
    return <></>;
  }

  return (
    <>
      <div title={"stagingBanner"} className={classes.stagingBanner}>
        <div title={"stagingBannerElement"} className={classes.stagingBannerElement}>
          <div title={"textColorWhite"} className={classes.textColorWhite}>Staging</div>
        </div>
      </div>
    </>
  )
}
